import {
  getCurrentLocale,
  getNamespaceMessages,
  setCurrentLocale,
  type Locale,
} from '@ngweditor/react'

/**
 * OMD-46 — lineset(구분선) 드롭다운 라벨 재번호.
 *
 * 이메일 안전 variant 4종(solid/solid-thin/solid-thick/dotted)만 노출하면서(NgwEditorLifecycle
 * toolbar.buttons 참조), dotted 가 드롭다운의 **4번째** 위치가 된다. 하지만 라이브러리 기본 라벨은
 * 원래 위치(6번째) 기준으로 `hrDotted = "구분선6"`(en `Line 6` / ja `区切り線6`) 이라, 노출 목록이
 * "구분선1·2·3·6" 처럼 끊겨 보인다. 위치에 맞춰 dotted 라벨을 "구분선4" 로 맞춘다.
 *
 * 라이브러리는 variant 별 라벨 커스터마이즈 prop 이 없고, 툴바 라벨은 **모듈 전역 message store**
 * (`locales[locale].toolbar`) 에서 읽는다(React context 아님 → `<Editor>`/`I18nProvider.messages`
 * 로는 바꿀 수 없다). export 된 `getNamespaceMessages()` 가 그 store 의 **live 참조**를 돌려주므로,
 * 지원 locale 전체에 대해 `hrDotted` 를 덮어써 다국어를 모두 반영한다. 최초 1회만 적용(멱등).
 *
 * 노출 variant 구성이 바뀌면 이 매핑도 함께 갱신할 것(NgwEditorLifecycle 의 lineset variants 와 짝).
 */
const DOTTED_LABEL_BY_LOCALE: Record<Locale, string> = {
  ko: '구분선4',
  en: 'Line 4',
  ja: '区切り線4',
}

let applied = false

export function applyNgwToolbarLabelOverrides(): void {
  if (applied) return
  applied = true

  const previousLocale = getCurrentLocale()
  try {
    ;(Object.keys(DOTTED_LABEL_BY_LOCALE) as Locale[]).forEach((locale) => {
      setCurrentLocale(locale)
      const toolbar = getNamespaceMessages('toolbar')
      if (toolbar != null && typeof toolbar.hrDotted === 'string') {
        toolbar.hrDotted = DOTTED_LABEL_BY_LOCALE[locale]
      }
    })
  } finally {
    setCurrentLocale(previousLocale)
  }
}
